import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { BOOKING_URL, isLiveUrl } from "../../config";

const bookingConfigured = isLiveUrl(BOOKING_URL);

// Shared booking behaviour — every "Book a call" button on the site
// reads BOOKING_URL from src/config.js. Edit it there, once.
export const handleBookingClick = (e) => {
  if (!bookingConfigured) {
    e.preventDefault();
    toast("Booking link not added yet", {
      description: "Paste your Google Calendar / Cal.com link into BOOKING_URL in src/config.js.",
    });
  }
};

const variants = {
  pill: "inline-flex items-center gap-2 whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-bold transition-colors duration-300 md:px-7 md:py-3 md:text-base",
  big: "inline-flex w-full items-center justify-center gap-3 whitespace-nowrap rounded-full px-8 py-4 text-lg font-bold transition-colors duration-300 sm:w-auto",
};

const tones = {
  navy: "bg-navy text-paper hover:bg-grape hover:text-navy",
  blush: "bg-blush text-navy hover:bg-sunny hover:text-navy",
  outline: "border-2 border-navy bg-transparent text-navy hover:bg-navy hover:text-paper",
};

export default function BookCallButton({
  variant = "pill",
  tone = "navy",
  className = "",
  testId,
  children,
}) {
  return (
    <motion.a
      data-testid={testId}
      href={bookingConfigured ? BOOKING_URL : "#book-a-call"}
      target={bookingConfigured ? "_blank" : undefined}
      rel={bookingConfigured ? "noopener noreferrer" : undefined}
      onClick={handleBookingClick}
      whileHover={{ scale: 1.04, rotate: -1 }}
      whileTap={{ scale: 0.96 }}
      className={`${variants[variant]} ${tones[tone]} ${className}`}
      aria-label="Book a call with the founder (opens in a new tab)"
    >
      {children}
      <ArrowRight className={variant === "big" ? "h-5 w-5" : "h-4 w-4"} aria-hidden="true" />
    </motion.a>
  );
}
